import { generatePath } from 'react-router-dom';

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import CloseIcon from '@mui/icons-material/Close';

import { billingSubscriptions, entity, entityHelp } from '#client/constants/routes';

export { ChevronLeftRoundedIcon, CloseIcon };

/**
 * Navigation targets for the restart flow, resolved from route templates in `constants/routes`.
 * @param {string} businessEntityUuid
 * @returns {{ dashboard: string, help: string, subscriptions: string }}
 */
export function getSubscriptionRestartPaths(businessEntityUuid) {
  if (!businessEntityUuid) {
    return {
      dashboard: '',
      help: '',
      subscriptions: '',
    };
  }

  return {
    dashboard: generatePath(entity, { businessEntityUuid }),
    help: generatePath(entityHelp, { businessEntityUuid }),
    subscriptions: billingSubscriptions,
  };
}
